module.exports = __webpack_public_path__ + "img/sequence-kyoto-gojo-sp.262a2618.jpg";